/* SLP carousel. Attaches to every [data-slp-carousel].
   Hooks: [data-slp-carousel-track], [data-slp-carousel-item], [data-slp-carousel-prev], [data-slp-carousel-next].
   Arrows scroll by two cards and disable at the ends. Mouse users can drag the track.
   Each carousel binds once, guarded by data-slp-init, so loading this file twice is harmless. */
(function () {
  var CARDS_PER_STEP = 2;
  var DRAG_THRESHOLD = 5;
  var EDGE_TOLERANCE = 2;

  function setup(root) {
    if (root.hasAttribute('data-slp-init')) return;
    var track = root.querySelector('[data-slp-carousel-track]');
    if (!track) return;
    root.setAttribute('data-slp-init', '');

    var prev = root.querySelector('[data-slp-carousel-prev]');
    var next = root.querySelector('[data-slp-carousel-next]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function stepSize() {
      var items = track.querySelectorAll('[data-slp-carousel-item]');
      if (!items.length) return track.clientWidth;
      var one = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth;
      return one * CARDS_PER_STEP;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= EDGE_TOLERANCE;
      if (next) next.disabled = track.scrollLeft >= max - EDGE_TOLERANCE;
    }

    function move(direction) {
      var smooth = !(reduceMotion && reduceMotion.matches);
      track.scrollBy({ left: direction * stepSize(), behavior: smooth ? 'smooth' : 'auto' });
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* Drag to scroll, mouse only. Touch keeps native scrolling. */
    var startX = 0;
    var startLeft = 0;
    var pressed = false;
    var dragged = false;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pressed = true;
      dragged = false;
      startX = event.clientX;
      startLeft = track.scrollLeft;
    });

    window.addEventListener('pointermove', function (event) {
      if (!pressed) return;
      var delta = event.clientX - startX;
      if (!dragged && Math.abs(delta) > DRAG_THRESHOLD) {
        dragged = true;
        track.classList.add('is-dragging');
      }
      if (dragged) {
        event.preventDefault();
        track.scrollLeft = startLeft - delta;
      }
    });

    function release() {
      if (!pressed) return;
      pressed = false;
      track.classList.remove('is-dragging');
      update();
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);

    /* A drag should not count as a click on anything inside a card. */
    track.addEventListener('click', function (event) {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }
    }, true);

    update();
  }

  function init() {
    var roots = document.querySelectorAll('[data-slp-carousel]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
